var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4601 6.73003C10.4601 8.79007 8.79007 10.4601 6.73003 10.4601C4.66999 10.4601 3 8.79007 3 6.73003C3 4.66999 4.66999 3 6.73003 3C8.79007 3 10.4601 4.66999 10.4601 6.73003ZM10.3091 12.4305C9.27238 13.0828 8.04526 13.4601 6.73003 13.4601C3.01314 13.4601 0 10.4469 0 6.73003C0 3.01314 3.01314 0 6.73003 0C10.4469 0 13.4601 3.01314 13.4601 6.73003C13.4601 8.04535 13.0827 9.27254 12.4304 10.3093L15.5561 13.4349C16.1419 14.0207 16.1419 14.9705 15.5561 15.5563C14.9703 16.1421 14.0206 16.1421 13.4348 15.5563L10.3091 12.4305Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.6c3eedfbb1a4620794d43eb8c5320e8c.svg";
export { ForwardRef as ReactComponent };